<template>
  <div
    class="custom-dropdown"
    :disabled="disabled"
    :class="[className, { active: isDropdownOpen }]"
    :ref="uniqueReferenceId"
    :id="id"
  >
    <button
      type="button"
      class="custom-dropdown-toggle"
      @click="toggleDropdown"
      :disabled="disabled"
      v-click-outside="closeDropdown"
    >
      <slot name="selected-option"></slot>
      <slot name="button-icon">
        <img
          class="button-icon"
          :src="require('../../assets/img/chevron-down.svg')"
        />
      </slot>
    </button>

    <ul v-if="isDropdownOpen" class="custom-dropdown-menu">
      <slot name="option-data"></slot>
    </ul>
  </div>
</template>

<script>
import { generateUUID } from '@/utils/helpers.js';
export default {
  name: 'CustomDropdown',
  data() {
    return {
      isDropdownOpen: false,
      id: null,
    };
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    className: {
      type: String,
      default: null,
    },
    isCaretVisible: {
      type: Boolean,
      default: true,
    },
    dropdownId: {
      type: String,
      required: false,
      default: null,
    },

    uniqueReferenceId: {
      type: String,
      default: null,
    },
    boundary: {
      default: 'scrollParent',
    },
  },
  mounted() {
    this.id = this.dropdownId
      ? this.dropdownId
      : `codelos-custom-dropdown-${generateUUID(4)}`;
  },
  methods: {
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
      if (this.isDropdownOpen) {
        setTimeout(() => {
          this.onDropdownOpen();
        });
      } else {
        this.onDropdownClose();
      }
    },
    closeDropdown() {
      this.isDropdownOpen = false;
      this.onDropdownClose();
    },
    onDropdownOpen() {
      const dropdownElement = document.querySelector(`#${this.id}`);
      const dropdownMenuElement = dropdownElement.querySelector(
        '.custom-dropdown-menu'
      );
      if (!dropdownMenuElement) return;
      const dropdownParentElement = this.getScrollParent(dropdownElement);
      const dropdownElementRect = dropdownElement.getBoundingClientRect();
      const dropdownParentElementRect =
        dropdownParentElement.getBoundingClientRect();

      const distanceAbove =
        dropdownElementRect.top - dropdownParentElementRect.top;
      const distanceBelow =
        dropdownParentElementRect.bottom - dropdownElementRect.top;
      if (distanceBelow > distanceAbove) {
        dropdownMenuElement.style.top = 0;
        dropdownMenuElement.style.bottom = 'unset';
      } else {
        dropdownMenuElement.style.top = 'unset';
        dropdownMenuElement.style.bottom = 0;
      }
      this.$emit('onDropdownOpen');
    },
    onDropdownClose() {
      this.$emit('onDropdownClose');
    },

    getScrollParent(element) {
      if (!element) {
        return null;
      }

      const overflowRegex = /(auto|scroll)/;

      function isScrollable(element) {
        const style = window.getComputedStyle(element);
        return overflowRegex.test(
          style.overflow + style.overflowY + style.overflowX
        );
      }

      let parent = element.parentElement;

      while (parent) {
        if (parent === document.body || parent === document.documentElement) {
          return document.body;
        }
        if (isScrollable(parent)) {
          return parent;
        }
        parent = parent.parentElement;
      }

      return document.documentElement;
    },
  },
};
</script>

<style scoped>
.custom-dropdown {
  position: relative;
  width: 100%;
  height: 100%;
  background: transparent;
}

.custom-dropdown .custom-dropdown-toggle {
  border: 0.5px solid #333343;
  border-radius: 4px;
  width: 100%;
  background: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-inline: 20px;
}

.custom-dropdown .custom-dropdown-toggle:disabled {
  background-color: rgba(0, 0, 0, 0.11);
  border: 1px solid rgba(0, 0, 0, 0.13);
  color: rgba(51, 51, 67, 0.29);
}

.custom-dropdown .custom-dropdown-toggle:disabled .button-icon {
  opacity: 0.4;
}

.custom-dropdown .custom-dropdown-toggle .button-icon {
  /* width: 9px; */
}

.custom-dropdown .custom-dropdown-menu {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 99;
  list-style: none;
  background-color: #ffffff;
  border-radius: 4px;
  height: fit-content;
  padding: 4px 8px;
  margin: 0;
  border: 0.5px solid #333343;
}
.custom-dropdown .custom-dropdown-menu li {
  width: 100%;
  height: 32px;
  display: flex;
  align-items: center;
}
.custom-dropdown ::v-deep .custom-dropdown-menu .dropdown-item {
  border-radius: 4px;
  /* height: 26px; */
  height: 26px;
  margin: 0px auto;
  padding-inline: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 150px;
  display: inline-block;
  line-height: 26px;
}
.custom-dropdown ::v-deep .custom-dropdown-menu .dropdown-item:hover {
  background-color: #ececec;
}
</style>
